if (typeof ScrollingText !== "function") {
	class ScrollingText extends HTMLElement {
		constructor() {
			super();

			this.track = this.querySelector(".scrolling-text__track");
			this.originalLoop = this.track ? this.track.firstElementChild : null;

			this.speed = window.innerWidth > 768
				? parseInt(this.dataset.scrollingSpeed, 10)
				: parseInt(this.dataset.scrollingSpeed, 10) / 1.5;

			this._setup = this._setup.bind(this);
			this._onResize = this._onResize.bind(this);
			this._resizeTimer = null;

			// Build enough copies to fill the width, and set the animation
			// variables. Runs once now, and again only on resize/image-load —
			// never inside the animation loop.
			this._setup();

			// An image inside the ORIGINAL loop finishing loading can change
			// its width — recheck once when that happens.
			if (this.originalLoop) {
				this.originalLoop.querySelectorAll("img").forEach((img) => {
					if (!img.complete) {
						img.addEventListener("load", this._setup, { once: true });
					}
				});
			}

			window.addEventListener("resize", this._onResize);

			if (this.dataset.pauseOnHover === "true") {
				let windowInFocus = true;
				window.addEventListener("blur", () => { windowInFocus = false; });
				window.addEventListener("focus", () => { windowInFocus = true; });

				this.addEventListener("mouseover", () => {
					if (windowInFocus) this.classList.add("is-paused");
				});
				this.addEventListener("mouseout", () => {
					if (windowInFocus) this.classList.remove("is-paused");
				});
			}

			// Pause the CSS animation (cheap) instead of stopping/restarting a JS loop.
			this._intersectionObserver = new IntersectionObserver((entries) => {
				this.classList.toggle("is-paused", !entries[0].isIntersecting);
			});
			this._intersectionObserver.observe(this);
		}

		_setup() {
			if (!this.track || !this.originalLoop) return;

			// Drop any previously-added clones, remeasure from the original only.
			while (this.track.children.length > 1) {
				this.track.removeChild(this.track.lastChild);
			}

			const copyWidth = this.originalLoop.getBoundingClientRect().width;
			if (!copyWidth) return;

			const containerWidth = this.getBoundingClientRect().width;
			// +1 extra copy so there's always a full container-width of content
			// still on screen at the moment the loop resets.
			const copiesNeeded = Math.max(2, Math.ceil(containerWidth / copyWidth) + 1);

			for (let i = 1; i < copiesNeeded; i++) {
				const clone = this.originalLoop.cloneNode(true);
				clone.setAttribute("aria-hidden", "true");
				this.track.appendChild(clone);
			}

			this.style.setProperty("--marquee-shift", `${copyWidth}px`);
			if (this.speed) {
				this.style.setProperty("--marquee-duration", `${copyWidth / this.speed}s`);
			}
		}

		_onResize() {
			clearTimeout(this._resizeTimer);
			this._resizeTimer = setTimeout(this._setup, 150);
		}

		disconnectedCallback() {
			window.removeEventListener("resize", this._onResize);
			if (this._intersectionObserver) this._intersectionObserver.disconnect();
		}
	}

	if (typeof customElements.get("scrolling-text") == "undefined") {
		customElements.define("scrolling-text", ScrollingText);
	}
}